import { motion } from "framer-motion";
import { ButtonsGroup } from "./ButtonsGroup";


type HighFiveButtonProps = {
    disableButton?: boolean;
    emoji: string;
    title: string;
    handleHighFive: () => void;
};

export const HighFiveButton = ({ disableButton = false, emoji = "✋", title = "Give me Five! You're doing great!", handleHighFive }: HighFiveButtonProps) => {
    return (
        <motion.div
            key="high-five"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.3 }}
            className="flex flex-col items-center gap-4"
        >
            <div className="text-osGrey-2 text-balance text-center px-4">
                {title}
            </div>
            <ButtonsGroup animated={false}>
                <motion.button type="button"
                    animate={{
                        rotate: [0, -10, 10, -10, 10, 0],
                        transition: {
                            duration: 0.6,
                            repeat: Infinity,
                            repeatDelay: 1.5,
                            ease: "easeInOut"
                        }
                    }}
                    whileTap={{ scale: 0.98 }}
                    transition={{ type: "spring", stiffness: 400, damping: 25 }}
                    className="rounded-full w-[144px] h-[144px] bg-osGrey-5 text-[84px] cursor-pointer"
                    disabled={disableButton}
                    onClick={handleHighFive}>{emoji}
                </motion.button>
                <p className="text-osGrey-2 text-balance text-center px-4">(tap the {emoji} to continue)</p>
            </ButtonsGroup>
        </motion.div>
    );
};